import React from "react";
import { useParams } from "react-router-dom";
import { apiCallPost, indianRupee, niceDate, niceDateTime } from "../util/util";
import "../Discharge.css";
import QRCode from "react-qr-code";
import {
  Button,
  ControlGroup,
  NonIdealState,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import _ from "lodash";
import { toWords } from "number-to-words";
import SafetyChecklistComponent from "./RxV21Cmp/SafetyChecklistComponent";
import BedHeadChecklist from "./RxV21Cmp/BedHeadChecklistComponent";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class SxPaymentLower extends React.Component {
  state = {
    isLoading: true,
    isFailure: false,
    sxId: null,
    hasLoaded: false,
    showTable: false,
  };

  foundCashRate = (item, payorItem) => {
    const cashRates = item.cashRates || [];
    let foundCashRate = null;
    for (let i = 0; i < cashRates.length; i++) {
      for (let cashRateBranch of cashRates[i].branches) {
        if (payorItem.branches.includes(cashRateBranch)) {
          foundCashRate = cashRates[i];
          break;
        }
      }
    }
    return foundCashRate;
  };

  componentDidMount() {
    let ss = this.props.params.sxId;

    this.setState({ sxId: ss });
    if (ss) {
      this.getSxPayment(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSxPayment = async (ss) => {
    try {
      let res = await apiCallPost("/print/sxPrints", {
        sxId: ss,
      });
      this.setState({ isLoading: false, hasLoaded: true, ...res }, () => {
        document.title = `${this.state.patientName} - ${this.state.branchInfo.hospital_name}`;
      });
    } catch (err) {
      cogoToast.error("Failed to load payment summary.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };

  renderHeader = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                alt="Client Logo"
                src={this.state.branchInfo.logoUrl}
                height="85px"
                width="auto"
                className="img_block"
              />
              <b
                style={{
                  fontSize: "9pt",
                  marginTop: "3px",
                  maxWidth: "120px",
                  textAlign: "center",
                }}
              >
                {this.state.branchInfo.hospital_name}
              </b>
            </div>
            <div>
              <b> {this.state.branchInfo.hospital_contact[0]}</b> <br />
              {this.state.branchInfo.hospital_contact[1]} <br />
              {this.state.branchInfo.hospital_contact[2]} <br />
              {this.state.branchInfo.hospital_contact[3]} <br />
              {this.state.branchInfo.ClinicPh} <br />
              {this.state.branchInfo.email} <br />
              Eye Bank: {this.state.branchInfo.EyeBankPh} <br />
              Insurance: {this.state.branchInfo.InsurancePh}
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            <div
              style={{
                marginLeft: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "right",
                maxWidth: "200px",
              }}
            >
              <div>
                <div style={{ textAlign: "left" }}>
                  {this.renderHorizontalText("BED HEAD CHECKLIST")}
                </div>

                {/* <b style={{ fontSize: "large" }}> {this.state.patientName}</b>{" "}
                <br /> {this.state.patientGenericPid}
                <br />
                DoB: {niceDate(this.state.patientDob)} | Sex:{" "}
                {this.state.patientSex} <br />
                Phone: {this.state.patientPhone}
                <br />
                Address: {this.state.patientAddress}
                <br />
                Surgery Date: <b>{niceDate(this.state.onDay)}</b> */}
              </div>
            </div>
            {/* <div
              style={{
                marginLeft: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <QRCode
                size={80}
                value={`https://print.newchart.care/sxPayment/${this.props.params.sxId}`}
                level="H"
              />
              <div
                style={{
                  fontSize: "x-small",
                  wordBreak: "break-all",
                  maxWidth: "150px",
                  textAlign: "center",
                }}
              >
                <code> {this.state.sxId}</code>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  };

  renderSxDetails = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("SURGERY DETAILS")}</>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Booked Time: <b>{niceDateTime(this.state.time)}</b>
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Surgeon: <b>{this.state.surgeonName}</b> | Operated Organ:{" "}
            <b>{this.state.eye}</b> | Anaesthesia:{" "}
            <b>{this.state.anaesthesiaType}</b>
          </Tag>
        </div>
      </div>
    );
  };
  renderLineItems = () => {
    if (this.state.showTable) {
      return <div>{this.renderLineItemsTable()}</div>;
    }
    return <div>{this.renderLineItemsConsolidated()}</div>;
  };
  renderLineItemsConsolidated = () => {
    if (!this.state.lineItems) {
      return null;
    }
    if (!this.state.lineItems.length) {
      return null;
    }
    // const paymentIndex = this.props.params.index;
    // console.log("paymentIndex", paymentIndex);
    // const payment = this.state.paymentEvents[paymentIndex];
    // console.log("payment", payment);
    // const computeNumberName = (n) => _.upperCase(toWords(n));
    return (
      <div style={{ marginBottom: "10px" }}>
        <BedHeadChecklist data={this.state} />
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <div>
            <h1>SIGN IN</h1>
            <div>
              <h2>Before giving Anaesthetia</h2>
            </div>
            
          </div>
          <div>
            <h1>TIME OUT</h1>
          </div>
        </div> */}
        {/* <div>{this.renderHorizontalText("PAYMENT DETAILS")}</div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>Payment Method</th>
              <th>Reference</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{payment.paymentMode}</td>
              <td>{payment.paymentRef}</td>
              <td>
                {indianRupee(payment.amountPaise) + " "}(
                {"RUPEES " +
                  computeNumberName(payment.amountPaise / 100) +
                  " ONLY"}
                )
              </td>
            </tr>
          </tbody>
        </table> */}
      </div>
    );
  };
  renderTermsAndFooter = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div style={{ textAlign: "left" }}>
                Please check that all details are correct. We will not be able
                to retrospectively correct panel and policy details.
              </div>
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div style={{ textAlign: "right" }}>
                {this.renderHorizontalText("E. & O. E.")}
              </div>
              <div style={{ textAlign: "right" }}>
                This is a combined invoice, statement of accounts and payments
                ledger.
              </div>
              <div style={{ textAlign: "right" }}>
                This is a computer generated invoice and does not require a
                signature.
              </div>
              <div style={{ textAlign: "right" }}>
                In case of queries, please reach out to us.
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    );
  };
  renderLineItemsTable = () => {
    if (!this.state.lineItems) {
      return null;
    }
    if (!this.state.lineItems.length) {
      return null;
    }
    return (
      <div style={{ marginBottom: "10px" }}>
        <div>{this.renderHorizontalText("DETAILS OF LINE ITEMS")}</div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>Type</th>
              <th>Item</th>
              <th>Quantity</th>
              <th>Per Unit Cost</th>
              <th>Total Amount</th>
            </tr>
          </thead>
          <tbody>{this.renderEachLineItem()}</tbody>
          <tfoot>
            <tr>
              <td colSpan={4} style={{ textAlign: "right" }}>
                <b> Total</b>
              </td>
              <td>
                <b>{indianRupee(this.state.totalBillAmountPaise)}</b>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };
  renderEachLineItem = () => {
    if (!this.state.lineItems) {
      return null;
    }
    if (!this.state.lineItems.length) {
      return null;
    }

    return this.state.lineItems.map((each) => {
      return (
        <tr>
          <td>
            {each.lineItemType === "SX"
              ? "Procedure"
              : each.lineItemType === "BED"
              ? "Bed/Ward"
              : _.startCase(_.lowerCase(each.lineItemType))}
          </td>
          <td>{each.item}</td>
          <td>{each.quantity}</td>
          <td>{indianRupee(each.ratePaise)}</td>
          <td>{indianRupee(each.ratePaise * each.quantity)}</td>
        </tr>
      );
    });
  };
  renderPayments = () => {
    if (!this.state.paymentEvents) {
      return null;
    }
    if (!this.state.paymentEvents.length) {
      return null;
    }
    return (
      <div>
        <div>
          {this.renderHorizontalText("LEDGER OF PAYMENTS MADE BY PATIENT")}
        </div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>Type</th>
              <th>Time</th>
              <th>Mode</th>
              <th>Reference</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>{this.renderEachPayment()}</tbody>
          <tfoot>
            <tr>
              <td colSpan={4} style={{ textAlign: "right" }}>
                <b> Total</b>
              </td>
              <td>
                <b>{indianRupee(this.state.totalCashPaidAmountPaise)}</b>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };
  renderEachPayment = () => {
    if (!this.state.paymentEvents) {
      return null;
    }
    if (!this.state.paymentEvents.length) {
      return null;
    }
    return this.state.paymentEvents.map((each, index) => {
      return (
        <tr>
          {" "}
          <td>{each.transactionType}</td>
          <td>{niceDateTime(each.ts)}</td>
          <td>{each.paymentMode}</td>
          <td>{each.paymentRef || "NA"}</td>
          <td>{indianRupee(each.amountPaise)}</td>
        </tr>
      );
    });
  };
  renderPanelDetails = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("PAYMENT PANEL DETAILS")}</>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Panel: <b>{this.state.chosenPanelName}</b> | Policy
            Number/Identification:{" "}
            <b>{this.state.patientPanelPolicyNumber || "NA"}</b>
          </Tag>
        </div>
      </div>
    );
  };
  renderPanelTrx = () => {
    if (!this.state.panelAuthorizationsHistory) {
      return null;
    }
    if (!this.state.panelAuthorizationsHistory.length) {
      return null;
    }
    return (
      <div>
        <div>
          {this.renderHorizontalText("LEDGER OF INSURANCE AUTHORIZATIONS")}
        </div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>Type</th>
              <th>Time</th>
              <th>Reference</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>{this.renderEachPanelTrx()}</tbody>
          <tfoot>
            <tr>
              <td colSpan={3} style={{ textAlign: "right" }}>
                <b>Cashless Amount</b>
              </td>
              <td>
                <b>{indianRupee(this.state.totalCashlessAmountPaise)}</b>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };
  renderEachPanelTrx = () => {
    if (!this.state.panelAuthorizationsHistory) {
      return null;
    }
    if (!this.state.panelAuthorizationsHistory.length) {
      return null;
    }
    return this.state.panelAuthorizationsHistory.map((each, index) => {
      return (
        <tr>
          {" "}
          <td>{each.typeOfAuthorization}</td>
          <td>{niceDateTime(each.ts)}</td>
          <td>{each.authorizationRef || "NA"}</td>
          <td>{indianRupee(each.amountPaise)}</td>
        </tr>
      );
    });
  };
  renderVerticalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          textOrientation: "upright",
          writingMode: "vertical-rl",
          marginRight: "10px",
          fontSize: "xx-small",
          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "110%",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid #b8a09e" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderTimeStamp = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "left",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="font__small">
            Last Updated: {niceDate(this.state.updatedAt)}
          </div>
          {this.state.consumedItems && this.state.consumedItems.length ? (
            <div className="font__small" style={{ maxWidth: "50vw" }}>
              Items as listed above are not an exhaustive list. Please contact
              the hospital surgery desk for a complete list.
            </div>
          ) : null}
        </div>
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.hasLoaded) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }

    return (
      <div
        className="rx__container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {" "}
        <style type="text/css" media="print">
          {" @page { size: A4 portrait !important; margin: 7mm !important;"}
        </style>
        <div>
          <div className="no__print">
            <ControlGroup>
              {/* <Button
                icon="settings"
                text="Toggle Line Item Details"
                onClick={() => {
                  this.setState({ showTable: !this.state.showTable });
                }}
                fill
              /> */}
              <Button
                icon="print"
                text="Print"
                onClick={() => {
                  window.print();
                }}
                fill
              />
            </ControlGroup>{" "}
          </div>
          {/* {this.renderHeader()} */}
          <hr />

          {/* {this.renderSxDetails()} */}
          {this.renderLineItems()}
          {/* {this.renderPanelDetails()} */}
          {/* {this.renderPanelTrx()} */}
          {/* {this.renderPayments()} */}
        </div>
        {/* <div style={{ position: "fixed", bottom: "0", width: "100vw" }}>
          <hr />
          <div> {this.renderTermsAndFooter()}</div>
        </div> */}
      </div>
    );
  }
}

const SxBedHeadChecklist = withRouter(SxPaymentLower);
export default SxBedHeadChecklist;
